import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronRight"><Path d="M9 4L17 12L9 20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronRight;
